<template>
    <div>
        <HeaderPage />
        <AlbumsBody />
    </div>
</template>

<script src="./AlbumsScreen.js"></script>